import i from "./index.es242.js";
import m from "./index.es119.js";
import l from "./index.es412.js";
import h from "./index.es413.js";
import w from "./index.es238.js";
import b from "./index.es122.js";
import C from "./index.es133.js";
import E from "./index.es235.js";
const R = (a) => {
  const e = b({}, a);
  let { data: n, withXSRFToken: r, xsrfHeaderName: d, xsrfCookieName: f, headers: o, auth: t } = e;
  if (e.headers = o = C.from(o), e.url = E(w(e.baseURL, e.url, e.allowAbsoluteUrls), a.params, a.paramsSerializer), t && o.set(
    "Authorization",
    "Basic " + btoa((t.username || "") + ":" + (t.password ? unescape(encodeURIComponent(t.password)) : ""))
  ), m.isFormData(n)) {
    if (i.hasStandardBrowserEnv || i.hasStandardBrowserWebWorkerEnv)
      o.setContentType(void 0);
    else if (m.isFunction(n.getHeaders)) {
      const s = n.getHeaders(), u = ["content-type", "content-length"];
      Object.entries(s).forEach(([p, c]) => {
        u.includes(p.toLowerCase()) && o.set(p, c);
      });
    }
  }
  if (i.hasStandardBrowserEnv && (r && m.isFunction(r) && (r = r(e)), r || r !== !1 && l(e.url))) {
    const s = d && f && h.read(f);
    s && o.set(d, s);
  }
  return e;
};
export {
  R as default
};
//# sourceMappingURL=index.es339.js.map
